import { IMAGES } from "../constent/theme"
import { Link } from "react-router-dom"
import emailjs from "@emailjs/browser"
import toast, { Toaster } from "react-hot-toast"
import { useRef, useState } from "react"
import { isStoreOpen } from "../Utilts/helper"

const Footer2 = () => {
  const heartRef = useRef(null)
  const [input, setInput] = useState("")
  const form = useRef(null)
  const sendEmail = e => {
    e.preventDefault()
    setInput("")
    if (form.current) {
      emailjs
        .sendForm(
          "emailId",
          "template_0byuv32",
          form.current,
          "qUDIPykc776NYHv4m"
        )
        .then(
          () => {
            toast.success("Successfully send!")
          },
          error => {
            toast.error(error.text)
          }
        )
    }
  }
  return (
    <>
      <Toaster position="bottom-right" reverseOrder={true} />
      <footer className="site-footer style-2 mt-5" id="footer">
        <div className="footer-bg-wrapper" id="app-banner">
          <div className="footer-top">
            <div className="container">
            
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 wow fadeInUp">
                    <div className="widget widget_getintuch">
  <h5 className="footer-title text-black">Contact</h5>
 
    <div className="row gy-4">
      {/* Cordova */}
      <div className="col-12">
        <h6 className="fw-bold text-black mb-2">
          Cordova Location{" "}
          <span
            className={`ms-2 fw-semibold ${
              isStoreOpen(7) ? "text-success" : "text-danger"
            }`}
          >
            {isStoreOpen(7) ? "Open Now" : "Closed"}
          </span>
        </h6>
        <p className="mb-1 text-black">
          <i className="flaticon-placeholder me-2"></i>
          <a
            href="https://www.google.com/maps/place/Petals+of+a+Peony/@35.1587011,-89.7944317,19z"
            target="_blank"
            rel="noreferrer"
            className="text-black text-decoration-none"
          >
            1250 N Germantown Pkwy #105, Cordova, TN
          </a>
        </p>
        <p className="mb-1 text-black">
          <i className="flaticon-telephone me-2"></i>
          <a href="tel:+19017078886" className="text-black text-decoration-none">
            (901) 707-8886
          </a>
        </p>
        <p className="mb-0 text-black">
          <i className="flaticon-clock me-2"></i>
          Mon–Sun: 11 AM – 9 PM<br />
          Tue: Closed
        </p>
      </div>

      {/* Overton */}
      <div className="col-12">
        <h6 className="fw-bold text-black mb-2">
          Overton Square Location{" "}
          <span
            className={`ms-2 fw-semibold ${
              isStoreOpen(11) ? "text-success" : "text-danger"
            }`}
          >
            {isStoreOpen(11) ? "Open Now" : "Closed"}
          </span>
        </h6>
        <p className="mb-1 text-black">
          <i className="flaticon-placeholder me-2"></i>
          <a
            href="https://www.google.com/maps/place/%E5%AF%8C%E8%B2%B4+Petals+of+a+Peony+(Midtown)/@35.1369614,-89.9921705,19z"
            target="_blank"
            rel="noreferrer"
            className="text-black text-decoration-none"
          >
            2110 Madison Ave, Memphis, TN 38104
          </a>
        </p>
        <p className="mb-1 text-black">
          <i className="flaticon-telephone me-2"></i>
          <a href="tel:+19012076680" className="text-black text-decoration-none">
            (901) 207-6680
          </a>
        </p>
        <p className="mb-0 text-black">
          <i className="flaticon-clock me-2"></i>
          Mon–Thu: 11 AM – 2:30 PM, 4:30 PM – 9:30 PM<br />
          Fri–Sat: 11 AM – 10 PM<br />
          Sun: 11 AM – 9:30 PM
        </p>
      </div>

      {/* Downtown */}
      <div className="col-12">
        <h6 className="fw-bold text-black mb-2">
          Downtown Memphis Location{" "}
          <span
            className={`ms-2 fw-semibold ${
              isStoreOpen(40) ? "text-success" : "text-danger"
            }`}
          >
            {isStoreOpen(40) ? "Open Now" : "Closed"}
          </span>
        </h6>
        <p className="mb-1 text-black">
          <i className="flaticon-placeholder me-2"></i>
          <a
            href="https://www.google.com/maps/place/149+Madison+Ave,+Memphis,+TN+38103"
            target="_blank"
            rel="noreferrer"
            className="text-black text-decoration-none"
          >
            149 Madison Ave, Memphis, TN 38103
          </a>
        </p>
        <p className="mb-1 text-black">
          <i className="flaticon-telephone me-2"></i>
          <a href="tel:+19016280086" className="text-black text-decoration-none">
            (901) 628-0086
          </a>
        </p>
        <p className="mb-0 text-black">
          <i className="flaticon-clock me-2"></i>
          Mon–Sat: 10 AM – 7 PM<br />
          Sun: Closed
        </p>
      </div>

      {/* Little Petals Chinese 2 (Poplar Ave Location, ID 73) */}
      <div className="col-12">
        <h6 className="fw-bold text-black mb-2">
          Poplar Ave Location{" "}
          <span
            className={`ms-2 fw-semibold ${
              isStoreOpen(73) ? "text-success" : "text-danger"
            }`}
          >
            {isStoreOpen(73) ? "Open Now" : "Closed"}
          </span>
        </h6>
        <p className="mb-1 text-black">
          <i className="flaticon-placeholder me-2"></i>
          <a
            href="https://www.google.com/maps/place/5167+Poplar+Ave,+Memphis,+TN+38117"
            target="_blank"
            rel="noreferrer"
            className="text-black text-decoration-none"
          >
            5167 Poplar Ave, Memphis, TN 38117
          </a>
        </p>
        <p className="mb-1 text-black">
          <i className="flaticon-telephone me-2"></i>
          <a href="tel:+19017233188" className="text-black text-decoration-none">
            (901) 723-3188
          </a>
        </p>
        <p className="mb-0 text-black">
          <i className="flaticon-clock me-2"></i>
          Mon–Sat: 10:30 AM – 8:30 PM<br />
          Sun: Closed
        </p>
      </div>

      {/* Little Petals 3 - Coming in 1 month */}
      <div className="col-12">
        <h6 className="fw-bold text-black mb-2">
          Little Petals 3{" "}
          <span className="ms-2 fw-semibold text-secondary">Coming in 1 month</span>
        </h6>
        <p className="mb-1 text-black">
          <i className="flaticon-placeholder me-2"></i>
          <a
            href="https://www.google.com/maps/search/890+W+Poplar+Ave"
            target="_blank"
            rel="noreferrer"
            className="text-black text-decoration-none"
          >
            890 W Poplar Ave, Memphis, TN 38117
          </a>
        </p>
      </div>

      {/* Little Petals 4 - Coming in 2 months */}
      <div className="col-12">
        <h6 className="fw-bold text-black mb-2">
          Little Petals 4{" "}
          <span className="ms-2 fw-semibold text-secondary">Coming in 2 months</span>
        </h6>
        <p className="mb-1 text-black">
          <i className="flaticon-placeholder me-2"></i>
          <a
            href="https://www.google.com/maps/place/551+S+Highland+St,+Memphis,+TN+38111"
            target="_blank"
            rel="noreferrer"
            className="text-black text-decoration-none"
          >
            551 S Highland St, Memphis, TN 38111
          </a>
        </p>
      </div>
    </div>
</div>

                </div>
                <div className="col-xl-3 col-lg-2 col-md-6 col-sm-6">
                  <div className="widget widget_services">
                    <h5 className="footer-title text-black  ">Our Links</h5>
                    <ul>
                      <li>
                        <Link to="/">
                          <span className="text-black">Home</span>
                        </Link>
                      </li>
                      {/* <li>
                        <Link to="/about-us">
                          <span className="text-black">About Us</span>
                        </Link>
                      </li> */}
                      
                      <li>
                        <Link to="/online-order">
                          <span className="text-black">Online Order</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/menu">
                          <span className="text-black">Menu</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <div className="widget widget_services">
                    <h5 className="footer-title text-black">OUR SERVICES</h5>
                    <ul>
                  
                      <li>
                        <Link to="/">
                          <span className="text-black">Top Chefs</span>
                        </Link>
                      </li>
                      {/* <li>
                        <Link to="/contact-us">
                          <span className="text-black">Services</span>
                        </Link>
                      </li> */}
                      <li>
                        <Link to="/online-order">
                          <span  className="text-black">Pickup In Store</span>
                        </Link>
                      </li>


                      <li>
                        <Link to="/online-order">
                          <span className="text-black">Delivery available </span>
                        </Link>
                      </li>
                     
                    </ul>
                  </div>
                </div>
                  
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="footer-bottom">
            <div className="row">
                <span className="copyright-text">
                  Crafted With{" "}
                  <span
                    className="heart"
                    ref={heartRef}
                    onClick={() => {
                      heartRef.current?.classList.toggle("heart-blast")
                    }}
                  ></span>{" "}
                  by{" "}
                  <Link to="/">
                    Petals Of A Peony
                  </Link>
                </span>
              </div>
              
            </div>
        </div>
      </footer>
    </>
  )
}

export default Footer2
